/* src/app/results/results.component.css */
.link_button {
  margin-right: 5px;
}
.link_button mat-icon {
  margin: 0 0;
}
.filter > * {
  min-width: 50%;
}
table {
  width: 100%;
}
.thumbnail {
  width: 75px;
  height: 75px;
  object-fit: cover;
}
.thumbnailBtn {
  cursor: pointer;
  width: 75px;
  height: 75px;
  background: none;
  position: relative;
  display: inline-block;
}
.thumbnailBorder {
  border-color: var(--primary-color);
  border-width: 2px;
  border-style: solid;
  width: 75px;
  height: 75px;
  border-radius: 5px;
}
.video_len {
  color: white;
  position: absolute;
  right: 0%;
  bottom: 0%;
  font-size: 10px;
}
.playIcon {
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  opacity: .75;
  font-size: 30px;
  width: 30px;
  height: 30px;
}
.mat-column-cre_date {
  max-width: 150px;
}
.mat-toolbar-row {
  background-color: #ffffff;
  justify-content: space-between;
}
.disabled_check {
  font-size: 16px;
  font-weight: normal;
  padding: 5px;
}
.hidden {
  display: none;
}
.bottom-toolbar {
  display: flex;
  flex: 1 1 auto;
  justify-content: space-between;
  flex-wrap: wrap;
}
.bottom-toolbar-button-group {
  line-height: 15px;
  font-size: 15px;
  margin: auto 0;
}
.mat-mdc-table {
  overflow-x: auto;
}
.scrollable_table {
  display: block;
  width: 100%;
  overflow-x: scroll;
}
.cell_button {
  color: var(--primary-color);
}
.fa_icon {
  font-size: 22px;
}
.mat-column-salesmail,
.mat-column-cre_date,
.mat-column-length,
.mat-column-opens,
.mat-column-views,
.mat-column-comments,
.mat-column-ctas,
.mat-column-reactions,
.mat-column-short_url,
.mat-column-send,
.mat-column-shares {
  text-align: center;
}
.green_button {
  background-color: var(--primary-color);
  color: #ffffff;
}
.button_text {
  color: #ffffff;
}
/*# sourceMappingURL=results.component.css.map */
